import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { EMPTY, Observable, catchError, from, mergeMap, take, throwError } from 'rxjs';

import { MaintenanceService } from './maintenance.service';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
    private maintenanceService = inject(MaintenanceService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            // eslint-disable-next-line rxjs-x/no-implicit-any-catch
            catchError((error: HttpErrorResponse) => {
                if (
                    !req.url.includes(`/${this.maintenanceService.pageLanguage}/maintenance`) &&
                    this.maintenanceService.statusCodes?.includes(error.status)
                ) {
                    return from(this.maintenanceService.isEnabled(this.maintenanceService.currentProduct)).pipe(
                        take(1),
                        mergeMap((isEnabled) => {
                            if (isEnabled) {
                                this.maintenanceService.goToMaintenance();
                                return EMPTY;
                            }
                            return throwError(() => error);
                        }),
                    );
                }
                return throwError(() => error);
            }),
        );
    }
}
